import { useMutation } from '@tanstack/react-query';
import { createTaskWithSubTasks } from 'shared/services/backend-api';
import { NewSubTask, NewTask } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';

export const useCreateTaskWithSubTasksMutation = () =>
  useMutation({
    mutationFn: async ({
      task,
      subTasks,
    }: {
      task: NewTask;
      subTasks: NewSubTask[];
    }) => {
      const taskToCreate = {
        ...task,
        endStrategy: task.endStrategy
          ? {
              deadline:
                task.endStrategy.deadline && !task.schedules?.length
                  ? task.endStrategy.deadline
                  : null,
              completionCount: task.endStrategy.completionCount ?? null,
            }
          : null,
      };

      if ('hideOnTodo' in task) {
        taskToCreate.hideOnTodo =
          task.type === TaskType.Habit ? task.hideOnTodo : null;
      }

      return createTaskWithSubTasks(taskToCreate, subTasks);
    },
  });
